"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var color_schemes_1 = require("../../controls/color-schemes");
/**
 * Epsilon Color Schemes Control Constructor
 */
wp.customize.controlConstructor['epsilon-color-scheme'] = wp.customize.Control.extend({
    ready: function () {
        var control = this, section, instance;
        wp.customize.bind('ready', function () {
            new color_schemes_1.EpsilonColorSchemes(control);
        });
        /**
         * Save the typography
         */
        control.container.on('change', '.epsilon-color-scheme-input', function (e) {
            control.setting.set(jQuery(e.target).val());
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/color-schemes.ts
// module id = 13
// module chunks = 0